require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./content-type-sandbox-sample-embedded-page-standalone-photo.json") })
        }
      }, "path---content-type-sandbox-sample-embedded-page-standalone-photo");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---content-type-sandbox-sample-embedded-page-standalone-photo!./.cache/json/content-type-sandbox-sample-embedded-page-standalone-photo.json
// module id = 1995
// module chunks = 231608221292675